<template>
  <v-container v-if="isLoaded">
    <v-row class="mt-5">
      <!-- Left Column - Manual Job Run -->
      <v-col cols="12" md="6" class="pr-md-2">
        <v-form ref="manual-job-runner-form">
          <v-card>
            <base-card-title
              icon="mdi-cogs"
              label="Manual Job run"
            />
            <v-alert
              v-if="errorMessages.length > 0"
              color="red lighten-2"
              dark
            >
              <ul
                v-for="(errorMessage, index) in errorMessages"
                :key="index"
              >
                <li>{{ errorMessage.message }}</li>
              </ul>
            </v-alert>
            <v-card-text class="pl-2 pr-2">
              <v-row class="pt-2 mb-2">
                <v-col
                  class="pb-0 pt-0"
                  md="6"
                >
                  <base-input-select
                    :items="availableJobs"
                    :rules="[rules.required]"
                    :selected-value="selectedJobName"
                    item-label="Job name"
                    item-text="description"
                    item-value="jobName"
                    @change="selectedJobName = arguments[0]"
                  />
                </v-col>
              </v-row>
            </v-card-text>
            <v-card-actions>
              <base-input-primary-button
                icon="mdi-reload"
                label="Start job"
                @click="triggerJob"
              />
            </v-card-actions>
          </v-card>
        </v-form>
      </v-col>

      <!-- Right Column - Running Jobs -->
      <v-col cols="12" md="6" class="pl-md-2">
        <v-card>
          <base-card-title
            icon="mdi-clipboard-list"
            label="Running Jobs"
          />
          <v-card-text class="pl-2 pr-2">
            <v-row v-if="runningJobs.length === 0" class="pt-2 mb-2">
              <v-col class="pb-0 pt-0">
                <p class="text-center grey--text">No jobs currently running</p>
              </v-col>
            </v-row>
            <v-row v-else class="pt-2">
              <v-col class="pb-0 pt-0">
                <v-list>
                  <v-list-item
                    v-for="job in runningJobs"
                    :key="job.jobName"
                    class="pl-0 pr-0"
                  >
                    <v-list-item-icon>
                      <v-icon color="warning">mdi-run</v-icon>
                    </v-list-item-icon>
                    <v-list-item-content>
                      <v-list-item-title>{{ job.jobName }}</v-list-item-title>
                    </v-list-item-content>
                  </v-list-item>
                </v-list>
              </v-col>
            </v-row>
          </v-card-text>
          <v-card-actions>
            <base-input-primary-button
              icon="mdi-refresh"
              label="Refresh"
              @click="refreshRunningJobs"
            />
          </v-card-actions>
        </v-card>
      </v-col>
    </v-row>

    <base-dialog-ok
      :dialog="successDialog"
      :label="successMessage"
      @ok="() => successDialog = false"
    />
  </v-container>
</template>
<script>
import BaseCardTitle from '@/base/card/BaseCardTitle.vue'
import BaseInputPrimaryButton from '@/base/input/BaseInputPrimaryButton.vue'
import axios from 'axios'
import BaseDialogOk from '@/base/dialog/BaseDialogOk.vue'
import BaseInputSelect from '@/base/input/BaseInputSelect.vue'

export default {
  name: 'ManualJobTrigger',
  components: {
    BaseInputSelect,
    BaseDialogOk,
    BaseInputPrimaryButton,
    BaseCardTitle
  },
  data () {
    return {
      isLoaded: false,
      successMessage: '',
      selectedJobName: '',
      availableJobs: [],
      runningJobs: [],
      errorMessages: [],
      successDialog: false,
      rules: {
        required: value => !!value || 'Required.'
      }
    }
  },
  mounted () {
    this.getAvailableJobs()
    this.refreshRunningJobs()
  },
  methods: {
    getAvailableJobs () {
      axios.get('/api/touchpoint/available-jobs')
        .then(response => {
          this.availableJobs = response.data
        })
        .then(() => {
          this.isLoaded = true
        })
    },
    refreshRunningJobs () {
      axios.get('/api/touchpoint/running-jobs')
        .then(response => {
          this.runningJobs = response.data
        })
        .catch(e => {
          console.log(e)
        })
    },
    triggerJob () {
      if (this.$refs['manual-job-runner-form'].validate()) {
        axios.post(`/api/touchpoint/manual-job-trigger?jobName=${this.selectedJobName}`)
          .then(response => {
            if (response.data.status === 'SUCCESS') {
              this.successMessage = 'Job successfully triggered'
              this.successDialog = true
              // Refresh running jobs after triggering
              this.refreshRunningJobs()
            } else {
              this.errorMessages = response.data.errorMessageList
              window.scrollTo(0, 0)
            }
          }).catch(e => {
            console.log(e)
          })
      }
    }
  }
}
</script>
